export const defaultStyles = {
  backgroundColor: "var(--theme-email-color-6)",
  padding: {
    paddingTop: "64",
    paddingBottom: "64",
    paddingLeft: "0",
    paddingRight: "0",
  },
  margin: {
    marginTop: "0",
    marginBottom: "0",
    marginLeft: "0",
    marginRight: "0",
  },
} as const;
